/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeRoleResponse } from '../../models/change-role-response';

export interface ChangeRole$Params {
  role: string;
}

export function changeRole(http: HttpClient, rootUrl: string, params: ChangeRole$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeRoleResponse>> {
  const rb = new RequestBuilder(rootUrl, changeRole.PATH, 'get');
  if (params) {
    rb.path('role', params.role, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangeRoleResponse>;
    })
  );
}

changeRole.PATH = '/auth/switch/role/{role}';
